import React, {useState, useEffect, useLayoutEffect, useRef} from "react"
import { css } from "@emotion/core"

import {themes} from '../Utility/Constants'

const modes = {
  CHOOSING: 'choosing',
  LOADING: 'loading',
  TYPING: 'typing'
}

const hamburgerWidth = 999

const BookChooser = (props) => {
  const [state, setState] = useState( () => {
    return {
      version: 'KJV',
      book: 'Genesis',
      startCh: 1,
      startVerse: 1,
      endVerse: 31,
      finalOptionSelected: true,
      stats: true,
      bannerText: '',
      userBeganTyping: false
    }
  })

  const [optionsState, setOptionsState] = useState(() => {
    return {
      hamburgerOn: false,
      hamburgerExpanded: false
    }
  })

  useLayoutEffect(() => {
    if (window.matchMedia("(max-width: " + hamburgerWidth + "px)").matches) {
      setOptionsState({
        hamburgerOn: true,
        hamburgerExpanded: false
      })
    }
  }, [])

  useEffect(() => {
    if (props.commandRef !== undefined && props.commandRef.current !== null) {
      props.commandRef.current = handleCommand
    }
  })
  
  //Media matching for switching between hamburger menu and full menu in navbar
  useEffect(()=>{
    const hamburgerOnHandler = (match) => {
      if (match.matches) { //Just matched the media
        setOptionsState({
          hamburgerOn: true,
          hamburgerExpanded: false
        })
      } else { //Just lost the match
        setOptionsState({
          hamburgerOn: false,
          hamburgerExpanded: false
        })
      }
    }
    const widthMatcher = window.matchMedia("(max-width: " + hamburgerWidth + "px)")
    // widthMatcher.addListener(handleHamburgerMode) 
    widthMatcher.addEventListener('change', hamburgerOnHandler)

    return( ()=>{
      // widthMatcher.removeListener(handleHamburgerMode)
      widthMatcher.removeEventListener('change', hamburgerOnHandler)
    })
  }, [optionsState.hamburgerOn])

  //User began typing effect (fade out instructions once they begin)
  useEffect(() => {
    console.log('typing mode useEffect')
    if (props.typingMode === modes.TYPING) {
      //As user is about to start typing, make banner instructions visible if they're not
      if (state.userBeganTyping) setState({ ...state, userBeganTyping: false })
    }
  }, props.typingMode)

  if (props.commandRef !== undefined && props.commandRef.current === null) props.commandRef.current = handleCommand

  function handleCommand(command) {

    const commandKey = Object.keys(command)[0]

    if (commandKey === 'handleTypingStarted') {
      if (!state.userBeganTyping) setState({...state, userBeganTyping: true})
    }
  }

  const instructionsRef = useRef()
  const version_Options = []
  const startCh_Options = []
  const startVerse_Options = []
  const endVerse_Options = []

  const versionNames = ['KJV', 'WEB']

  for (const version of versionNames){
    let option = <option key={'VersionOption' + version}
    value={version}>{version}</option>
    version_Options.push(option)
  }

  const bookNamesOrdered = versionData[state.version].bookNames
  const OT_Books = bookNamesOrdered.slice(0,39)
  const NT_Books = bookNamesOrdered.slice(39, bookNamesOrdered.length)

  let OT_Book_Options = []
  for (let i = 0; i < OT_Books.length; i++){
    let option = <option key={'OTOption' + OT_Books[i]}
      value={OT_Books[i]}>{OT_Books[i]}</option>
    OT_Book_Options.push(option)
  }

  let NT_Book_Options = []
  for (let i = 0; i < NT_Books.length; i++){
    let option = <option key={'NTOption' + NT_Books[i]}
      value={NT_Books[i]}>{NT_Books[i]}</option>
    NT_Book_Options.push(option)
  }

  const chosenBookData = versionData[state.version].bookInfo[state.book]
  //chapter choices
  for (let i = 0; i < chosenBookData.chapters; i++) {
    let startOption = <option key={'startCH' + (i + 1)}
      value={i + 1}>{i + 1}</option>
    startCh_Options.push(startOption)
  }

  //start and end verse choices
  endVerse_Options.push(<option key='endVerseFinal' value='final'>{'final'}</option>)

  for (let i = 0; i < chosenBookData.versesPerChapter[state.startCh - 1]; i++){
    let startVerseOption = <option key={'startVerse' + (i + 1)}
      value={i + 1}>{i + 1}</option>
    startVerse_Options.push(startVerseOption)

    let endVerseOption = <option key={'endVerse' + (i + 1)}
      value={i + 1}>{i + 1}</option>
    endVerse_Options.push(endVerseOption)
  }

  function handleVersionSelect(e) {
    const chosenVersion = e.target.value
    if (chosenVersion === state.version) return

    //Book names are identical between KJV and WEB so that doesn't have to change. But there's a spot in WEB Romans (many versions of Romans) where verses are less for a particular ch b/c they're put in a different ch. So I'll just do all the verse logic from handleBookSelect here too to be safe. I'll do ch logic too incase there's some future weird version with less chapters than normal for whatever reason.

    let startCh, startVerse, endVerse
    const newBookData =  versionData[chosenVersion].bookInfo[state.book]

    let maxCh = newBookData.chapters

    startCh = state.startCh > maxCh ? maxCh : state.startCh

    let maxVerse = newBookData.versesPerChapter[startCh - 1]

    startVerse = state.startVerse > maxVerse ? maxVerse : state.startVerse

    if (state.finalOptionSelected) endVerse = maxVerse
    else endVerse = state.endVerse > maxVerse ? maxVerse : state.endVerse

    setState({
      ...state,
      version: chosenVersion,
      startCh: startCh,
      startVerse: startVerse,
      endVerse: endVerse
    })
  }

  function handleBookSelect(e) {
    const chosenBook = e.target.value

    let startCh, startVerse, endVerse
    const newBookData =  versionData[state.version].bookInfo[chosenBook]

    let maxCh = newBookData.chapters

    startCh = state.startCh > maxCh ? maxCh : state.startCh

    let maxVerse = newBookData.versesPerChapter[startCh - 1]

    startVerse = state.startVerse > maxVerse ? maxVerse : state.startVerse

    if (state.finalOptionSelected) endVerse = maxVerse
    else endVerse = state.endVerse > maxVerse ? maxVerse : state.endVerse

    setState({
      ...state,
      book: chosenBook,
      startCh: startCh,
      startVerse: startVerse,
      endVerse: endVerse
    })
  }

  function handleChSelect(e) {
    let startCh, startVerse, endVerse

    startCh = parseInt(e.target.value)
    //if end ch is updated, check if current end verse is too high for new end ch
    //prior start verse may be too high for newly chosen start ch

    let maxVerse = chosenBookData.versesPerChapter[startCh - 1]

    startVerse = state.startVerse > maxVerse ? maxVerse : state.startVerse

    if (state.finalOptionSelected) endVerse = maxVerse
    else endVerse = state.endVerse > maxVerse ? maxVerse : state.endVerse

    setState({
      ...state,
      startCh: startCh,
      startVerse: startVerse,
      endVerse: endVerse
    })
  }

  function handleStartVerseSelect(e) {
    let startVerse = parseInt(e.target.value)
    let endVerse = state.endVerse

    if (startVerse > endVerse) {
      endVerse = startVerse
    }

    setState({
      ...state,
      startVerse: startVerse,
      endVerse: endVerse
    })
  }

  function handleEndVerseSelect(e) {
    let maxVerse = chosenBookData.versesPerChapter[state.startCh - 1]
    let finalOptionSelected = false
    let endVerse = parseInt(e.target.value)

    if (e.target.value === 'final') {
      endVerse = maxVerse
      finalOptionSelected = true
    }

    let startVerse = state.startVerse

    if (endVerse < startVerse) {
      startVerse = endVerse
    }

    setState({
      ...state,
      startVerse: startVerse,
      endVerse: endVerse,
      finalOptionSelected: finalOptionSelected
    })
  }

  function handleStatsCheckbox(e) {
    setState({
      ...state,
      stats: e.target.checked
    })
  }

  function handleBegin(e) {
    let displayText = state.book + ' ' + state.startCh + ':' + state.startVerse
    if (state.endVerse > state.startVerse) {
      displayText = displayText + '-' + state.endVerse
    }

    //begin was pressed
    if (props.typingMode === modes.CHOOSING) {
      setState({
        ...state,
        bannerText: displayText
      })
      //we don't have to worry that the above update won't be included here since the index doesn't care about bannerText
      props.choiceCallback(state)
    }
    //cancel was pressed
    else if (props.typingMode === modes.TYPING) {
      props.cancelCallback()
    }
  }

  function handleOptions(e) {
    setOptionsState({
      ...optionsState,
      hamburgerExpanded: !optionsState.hamburgerExpanded
    })
  }

  const optionsDisabled = props.typingMode !== modes.CHOOSING ? true : false;

  //If typing mode has initiated but the hamburger options hasn't been closed, we need to close it
  if (props.typingMode === modes.TYPING && optionsState.hamburgerExpanded) {
    setOptionsState({
      ...optionsState,
      hamburgerExpanded: false
    })
  }

  //^ Return
  return (
    <div css={getCSS(themes)}>
      {optionsState.hamburgerOn &&
      <button
      key='options-button'
      className='action-button options-button'
      onClick={handleOptions}
      disabled={props.typingMode !== modes.CHOOSING ? true : false}
      >
        {'OPTIONS'}
      </button> }

      <div key='options-container' className={'options-container ' + (optionsState.hamburgerExpanded ? 'hamburgerExpanded' : '')}>

        <div className='choice-container'>
          <div id='version-label' className='choice-label'>VERSION</div>
          <div className='select-decoration-container'>
            <select name="Version" id='version-select' className='choice-select' onChange={handleVersionSelect} value={state.version} disabled={optionsDisabled}>
              {version_Options}
            </select>
          </div>
        </div>

        <div className='choice-container'>
          <div className='choice-label'>BOOK</div>
          <div className='select-decoration-container'>
            <select name="Book" id="book-select" className='choice-select' onChange={handleBookSelect} value={state.book} disabled={optionsDisabled}>
              <optgroup label="Old Testament">
                {OT_Book_Options}
              </optgroup>
              <optgroup label="New Testament">
                {NT_Book_Options}
              </optgroup>
            </select>
          </div>
        </div>

        <div className='choice-container'>
          <div className='choice-label'>Chapter</div>
          <div className='select-decoration-container'>
            <select name="Start-Ch" id="startCh-select" className='choice-select' onChange={handleChSelect} value={state.startCh} disabled={optionsDisabled}>
              {startCh_Options}
            </select>
          </div>
        </div>

        <div className='choice-container'>
          <div id='from-label' className='choice-label'>Verse start</div>
          <div className='select-decoration-container'>
            <select name="Start-Verse" id="startVerse-select" className='choice-select' onChange={handleStartVerseSelect} value={state.startVerse} disabled={optionsDisabled}>
              {startVerse_Options}  
            </select>
          </div>
        </div>

        <div className='choice-container'>
          <div id='to-label' className='choice-label'>Verse end</div>
          <div className='select-decoration-container'>
            <select name="End-Verse" id="endVerse-select" className='choice-select' onChange={handleEndVerseSelect} value={state.finalOptionSelected ? 'final' : state.endVerse} disabled={optionsDisabled}>
              {endVerse_Options}
            </select> 
          </div>
        </div>

        <div className='choice-container'>
          <label htmlFor='wpm_toggle' className='choice-label'>WPM Results</label>
          <label className="switch">
            <input type="checkbox" checked={state.stats} onChange={handleStatsCheckbox} disabled={optionsDisabled}/>
            <span className="slider"></span>
          </label>
        </div>

        {/*//.info-banner royally screwed up transition animations on Safari when it was a part of the options container during hamburger mode. So make sure it isn't. */}

        {!optionsState.hamburgerOn && <div key='info-banner' className={'info-banner ' + (props.typingMode === modes.TYPING ? 'reveal' : '')}>
          <div id='info-banner-inner-dec'>
            <div className='info-label'>{state.bannerText}</div>
            <div className={'instruction-label ' + (state.userBeganTyping ? 'hide-instructions' : '')} ref={instructionsRef}>(you may begin typing)</div>
          </div>
        </div>}
        
      </div> {/*end options-container */}

      <button key='begin-button'
        id='begin-button'
        className={'action-button begin-button' + (props.typingMode === modes.CHOOSING ? 'begin' : '') + (props.typingMode === modes.TYPING ? 'cancel' : '')}
        onClick={handleBegin}
        disabled={props.typingMode === modes.LOADING ? true : false}
      >
        {props.typingMode === modes.CHOOSING && 'BEGIN'}
        {props.typingMode === modes.LOADING && <div id='loading-div-shadow'/>}
        {props.typingMode === modes.LOADING && <div id='loading-div' />}
        {props.typingMode === modes.TYPING && 'CANCEL'}
      </button>

      {optionsState.hamburgerOn && <div key='info-banner' className={'info-banner ' + (props.typingMode === modes.TYPING ? 'reveal' : '')}>
        <div id='info-banner-inner-dec'>
          <div className='info-label'>{state.bannerText}</div>
          <div className={'instruction-label ' + (state.userBeganTyping ? 'hide-instructions' : '')} ref={instructionsRef}>(you may begin typing)</div>
        </div>
      </div>}
    </div>
  )
}
export default BookChooser

//^ CSS
const per = '%'
const px = 'px'
const rem = 'rem'
const vw='vw'

const getCSS = (t) => css`
display: flex;
justify-content: center;
padding: 1rem 0;
margin-bottom: 2.5rem;
font-size: 1.35rem;
flex-shrink: 0; //this thing shrinks on safari, so I need this to prevent it

.options-container {
  position: relative;
  display: flex;
  justify-content: center;
  margin-right: 2rem;
}

.info-banner {
  position: absolute;
  left: 0;
  //this is currently nested in the options-container, so account for 1rem padding of BookChooser so this will rest at top of screen when shown.
  top: -1rem;
  width: 100%;
  height: calc(100${per} + 1.5${rem});
  background-color: ${t.bannerColorMain}; //dark red
  transform: translate(0, -150%);
  transition: transform 1s;

  border: 7px solid ${t.bannerColorMain};
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  /* border-right-color: #790000; //darkest red
  border-bottom-color: #8c0000; //darker red */
  border-style: outset;
  border-top-width: 0;
  box-shadow: 7px 10px 20px -7px black;
  background-image: linear-gradient(170deg, rgba(0,0,0,0), rgba(0,0,0,0.03), rgba(0,0,0,0.07), rgba(0,0,0,0.4));
}

#info-banner-inner-dec {
  position: absolute;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: calc(100${per} - 12${px});
  height: 100%;
  left: 0;
  right: 0;
  margin: auto;
  bottom: 6px;
  background-color: ${t.bannerColorMain};
  border: 3px solid ${t.bannerColor2}; //the dark blue
  //always use this outline b/c sometimes border doesn't fully overlap the parent div's background
  outline: 5px solid ${t.bannerColor2};
  outline-offset: 4px;
  border-top-width: 0;
  background-image: linear-gradient(175deg, rgba(0,0,0,0), rgba(0,0,0,0.05), rgba(0,0,0,0.15), rgba(0,0,0,0.3));
}

.info-label {
  //this rests in the inner-dec div which is 6px offset upward from the banner to allow the banner bottom border to show. So account for that.
  margin-top: calc(6${px} + 1.25${rem});
  font-size: 2rem;
  color: ${t.textColor};
  letter-spacing: 1px;
  text-shadow: 1px 1px 1px black, 2px 2px 1px black;
}

.instruction-label {
  margin-top: 0.25rem;
  font-size: 1rem;
  color: ${t.textColor};
  letter-spacing: 1px;
  text-shadow: 1px 1px 1px black, 2px 2px 1px black;
}

.hide-instructions {
  opacity: 0;
  transition: opacity 1s;
}

.reveal {
  transform: translate(0, 0rem);
  transition: transform 1.5s;
}

.choice-container{
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 2rem;
}

.choice-container:first-of-type{
  margin-left: 0;
}

.choice-label{
  color: ${t.textColor};
  /* color: ${t.borderColor}; */
  letter-spacing: 1px;
  margin: 0 0 1rem 0;
  text-shadow: 1px 1px 1px black, 2px 2px 1px black, 3px 3px 1px black;
}

.choice-select {
  background-color: ${t.textBgColor};
  padding: 0.3725rem 0.125rem;
  font-size: 1.25rem;
  border-radius: 5px;
  min-width: 5rem;
  border: 2px solid gray;
}

.choice-select:focus {
  outline: none;
}

.select-decoration-container {
  padding: 1px;
  background-color: ${t.borderColor};
  border: 2px solid ${t.borderColor};
  border-style: outset;
  background-image: linear-gradient(135deg, rgba(0,0,0,0), rgba(0,0,0,0.25));
  box-shadow: 7px 10px 20px -7px black;
}

.action-button {
  font-family: 'Times New Roman';
  font-size: 1.25rem;
  position: relative;

  width: 7rem;
  height: 3rem;

  align-self: center;
  padding: 0.25rem 0;
  background-color: ${t.bgColor};
  background-color: ${t.buttonColor};
  color: ${t.textColor};
  border: 5px outset ${t.buttonColor};
  border-radius: 0.35rem;
  text-shadow: 1px 1px 1px black, 2px 2px 1px black;
}

.action-button:active {
  border-style: inset;
}

.action-button:focus {
  outline: none;
}

//^ media queries

@media (max-width: 1300px) {

  .choice-container {
    margin: 0 calc(32${px} - ((1300${px} - 100${vw}) * 16 / 200));
  }
  .choice-select {
    font-size: 1.25rem;
  }
}

@media (max-width: 1100px) {
  font-size: 1.25rem;

  .choice-container {
    margin: 0 0.75rem;
  }

  .choice-select {
    font-size: 1rem;
    min-width: 4rem;
  }
}

@media (max-width: ${hamburgerWidth}px) {
  position: relative;
  justify-content: space-between;
  height: 5rem;
  min-height: 5rem;
  padding: 0 5%;

  .info-banner {
    left: 5%;
    //account for the 10% padding of the BookChooser in this smaller screen size, the 7rem width of the action button, and add 2rem breathing room between
    width: calc(90${per} - 9${rem});
    //no longer nested in options-container so we don't have to account for an extra 1rem of padding to rest at top of screen
    top: 0;
    height: 100%;
  }

  .info-label {
    margin-top: calc(6${px} + 0.75${rem});
    font-size: 1.5rem;
  }

  .instruction-label {
    margin-top: 0;
    font-size: 0.8rem;
  }

  .options-container {
    z-index: 2;
    flex-direction: column;
    position: absolute;
    margin-right: 0;
    top: 100%;
    background-color: ${t.bgColorDark}; //darker brown
    padding: 0 0.5rem 0.5rem 0;
    border: 4px solid ${t.borderColor};
    border-style: outset;
    border-left: none;

    right: 100%;
    transform: translateX(0);
    transition: transform 1s;
  }

  .hamburgerExpanded {
    transform: translateX(100%);
    transition: transform 1s;
  }

  .choice-container{
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin: 0.5rem;
  }

  .choice-container:first-of-type{
    margin-left: 0.5rem;
  }

  .choice-label {
    margin: 0 1rem 0 0;
  }
}

//things getting smushed, compensate
@media (max-width: 550px) {
  padding: 0;
  .info-banner{ 
    width: calc(100${per} - 7${rem} - 10${px});
    left: 5px;
    border-width: 5px;
    border-top-width: 0px;
  }

  #info-banner-inner-dec {
    border: 2px solid #00005c; //the dark blue
    border-top: none;

    outline-width: 3px;
    outline-offset: 2px;
    width: calc(100${per} - 6${px});
    bottom: 3px;
  }

  .action-button {
    font-size: 1rem;
    width: 6rem;
    padding: 0;
    height: 2.5rem;
    margin-right: 5px;
    margin-left: 5px;
  }
}

@media (max-width: 450px) {
  .info-banner{ 
    width: calc(100${per} - 5.75${rem} - 10${px});
  }

  .info-label {
    margin-top: calc(6${px} + 1${rem});
    font-size: 1.15rem;
  }

  .instruction-label {
    font-size: 0.8rem;
    margin-top: 0.1rem;
  }

  .action-button {
    font-size: 0.9rem;
    width: 5rem;
  }
}

@media (max-width: 349px) {
  .info-banner{ 
    width: calc(100${per} - 5.75${rem} - 10${px});
  }

  .info-label {
    margin-top: calc(6${px} + 1${rem});
    font-size: 1rem;
  }

  .instruction-label {
    margin-top: 0.5rem;
  }
}

.begin {
  animation: fadeInForBegin 1s;
}

.cancel {
  animation: fadeInForCancel 1s;
}

@keyframes fadeInForBegin {
  from {color: rgba(236,201,0,0); text-shadow: 1px 1px 1px rgba(0,0,0,0), 2px 2px 1px rgba(0,0,0,0)}
  to {color: rgba(236,201,0,1); text-shadow: 1px 1px 1px rgba(0,0,0,1), 2px 2px 1px rgba(0,0,0,1)}
}

@keyframes fadeInForCancel {
  from {color: rgba(236,201,0,0); text-shadow: 1px 1px 1px rgba(0,0,0,0), 2px 2px 1px rgba(0,0,0,0)}
  to {color: rgba(236,201,0,1); text-shadow: 1px 1px 1px rgba(0,0,0,1), 2px 2px 1px rgba(0,0,0,1)}
}

#loading-div {
  height: 1.25rem;
  width: 1.25rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  border-radius: 50%;
  border: 4px solid ${t.textColor};
  border-color: ${t.textColor} transparent ${t.textColor} transparent;
  animation: spinning 1.2s linear infinite;
}

#loading-div-shadow {
  height: 1.5rem;
  width: 1.5rem;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;

  border-radius: 50%;
  border: 7px solid black;
  border-color: black transparent black transparent;
  animation: spinning 1.2s linear infinite;
}

@keyframes spinning {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);  
  }
}

/* The switch - the box around the slider */
.switch {
  box-sizing: content-box;
  position: relative;
  display: inline-block;
  background-color: black;
  width: 60px;
  height: 34px;
  border-radius: 4px;
  border: 5px solid ${t.buttonColor};
  border-style: inset;
}

/* Hide default HTML checkbox */
.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #250f00;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 4px;
}

.slider:before {
  position: absolute;
  content: "";
  height: 18px;
  width: 18px;
  left: 3px;
  bottom: 3px;
  -webkit-transition: .4s;
  transition: .4s;
  border-radius: 4px;
  background-color: ${t.buttonColor};
  border: 5px outset ${t.buttonColor}
}

input:checked + .slider {
  //darker than typical light theme color
  background-color: #c8a900;
}

input:checked + .slider:before {
  -webkit-transform: translateX(26px);
  -ms-transform: translateX(26px);
  transform: translateX(26px);
}
`

//^ JSON Data

// First key is version name. Then you can either see bookInfo or bookNames. 
// bookInfo is an object with book name keys, containing "chapters"(total number of chapters) and "versesPerChapter"(array with total verses per each chapter; the array length is the total chapters)
// bookNames is just an array of the names for each book for that version in proper order
const versionData = {
  KJV: {
    bookInfo: {
      "1 Chronicles": { "chapters": 29, "versesPerChapter": [54, 55, 24, 43, 26, 81, 40, 40, 44, 14, 47, 40, 14, 17, 29, 43, 27, 17, 19, 8, 30, 19, 32, 31, 31, 32, 34, 21, 30] }, "1 Corinthians": { "chapters": 16, "versesPerChapter": [31, 16, 23, 21, 13, 20, 40, 13, 27, 33, 34, 31, 13, 40, 58, 24] }, "1 John": { "chapters": 5, "versesPerChapter": [10, 29, 24, 21, 21] }, "1 Kings": { "chapters": 22, "versesPerChapter": [53, 46, 28, 34, 18, 38, 51, 66, 28, 29, 43, 33, 34, 31, 34, 34, 24, 46, 21, 43, 29, 53] }, "1 Peter": { "chapters": 5, "versesPerChapter": [25, 25, 22, 19, 14] }, "1 Samuel": { "chapters": 31, "versesPerChapter": [28, 36, 21, 22, 12, 21, 17, 22, 27, 27, 15, 25, 23, 52, 35, 23, 58, 30, 24, 42, 15, 23, 29, 22, 44, 25, 12, 25, 11, 31, 13] }, "1 Thessalonians": { "chapters": 5, "versesPerChapter": [10, 20, 13, 18, 28] }, "1 Timothy": { "chapters": 6, "versesPerChapter": [20, 15, 16, 16, 25, 21] }, "2 Chronicles": { "chapters": 36, "versesPerChapter": [17, 18, 17, 22, 14, 42, 22, 18, 31, 19, 23, 16, 22, 15, 19, 14, 19, 34, 11, 37, 20, 12, 21, 27, 28, 23, 9, 27, 36, 27, 21, 33, 25, 33, 27, 23] }, "2 Corinthians": { "chapters": 13, "versesPerChapter": [24, 17, 18, 18, 21, 18, 16, 24, 15, 18, 33, 21, 14] }, "2 John": { "chapters": 1, "versesPerChapter": [13] }, "2 Kings": { "chapters": 25, "versesPerChapter": [18, 25, 27, 44, 27, 33, 20, 29, 37, 36, 21, 21, 25, 29, 38, 20, 41, 37, 37, 21, 26, 20, 37, 20, 30] }, "2 Peter": { "chapters": 3, "versesPerChapter": [21, 22, 18] }, "2 Samuel": { "chapters": 24, "versesPerChapter": [27, 32, 39, 12, 25, 23, 29, 18, 13, 19, 27, 31, 39, 33, 37, 23, 29, 33, 43, 26, 22, 51, 39, 25] }, "2 Thessalonians": { "chapters": 3, "versesPerChapter": [12, 17, 18] }, "2 Timothy": { "chapters": 4, "versesPerChapter": [18, 26, 17, 22] }, "3 John": { "chapters": 1, "versesPerChapter": [14] }, "Acts": { "chapters": 28, "versesPerChapter": [26, 47, 26, 37, 42, 15, 60, 40, 43, 48, 30, 25, 52, 28, 41, 40, 34, 28, 41, 38, 40, 30, 35, 27, 27, 32, 44, 31] }, "Amos": { "chapters": 9, "versesPerChapter": [15, 16, 15, 13, 27, 14, 17, 14, 15] }, "Colossians": { "chapters": 4, "versesPerChapter": [29, 23, 25, 18] }, "Daniel": { "chapters": 12, "versesPerChapter": [21, 49, 30, 37, 31, 28, 28, 27, 27, 21, 45, 13] }, "Deuteronomy": { "chapters": 34, "versesPerChapter": [46, 37, 29, 49, 33, 25, 26, 20, 29, 22, 32, 32, 18, 29, 23, 22, 20, 22, 21, 20, 23, 30, 25, 22, 19, 19, 26, 68, 29, 20, 30, 52, 29, 12] }, "Ecclesiastes": { "chapters": 12, "versesPerChapter": [18, 26, 22, 16, 20, 12, 29, 17, 18, 20, 10, 14] }, "Ephesians": { "chapters": 6, "versesPerChapter": [23, 22, 21, 32, 33, 24] }, "Esther": { "chapters": 10, "versesPerChapter": [22, 23, 15, 17, 14, 14, 10, 17, 32, 3] }, "Exodus": { "chapters": 40, "versesPerChapter": [22, 25, 22, 31, 23, 30, 25, 32, 35, 29, 10, 51, 22, 31, 27, 36, 16, 27, 25, 26, 36, 31, 33, 18, 40, 37, 21, 43, 46, 38, 18, 35, 23, 35, 35, 38, 29, 31, 43, 38] }, "Ezekiel": { "chapters": 48, "versesPerChapter": [28, 10, 27, 17, 17, 14, 27, 18, 11, 22, 25, 28, 23, 23, 8, 63, 24, 32, 14, 49, 32, 31, 49, 27, 17, 21, 36, 26, 21, 26, 18, 32, 33, 31, 15, 38, 28, 23, 29, 49, 26, 20, 27, 31, 25, 24, 23, 35] }, "Ezra": { "chapters": 10, "versesPerChapter": [11, 70, 13, 24, 17, 22, 28, 36, 15, 44] }, "Galatians": { "chapters": 6, "versesPerChapter": [24, 21, 29, 31, 26, 18] }, "Genesis": { "chapters": 50, "versesPerChapter": [31, 25, 24, 26, 32, 22, 24, 22, 29, 32, 32, 20, 18, 24, 21, 16, 27, 33, 38, 18, 34, 24, 20, 67, 34, 35, 46, 22, 35, 43, 55, 32, 20, 31, 29, 43, 36, 30, 23, 23, 57, 38, 34, 34, 28, 34, 31, 22, 33, 26] }, "Habakkuk": { "chapters": 3, "versesPerChapter": [17, 20, 19] }, "Haggai": { "chapters": 2, "versesPerChapter": [15, 23] }, "Hebrews": { "chapters": 13, "versesPerChapter": [14, 18, 19, 16, 14, 20, 28, 13, 28, 39, 40, 29, 25] }, "Hosea": { "chapters": 14, "versesPerChapter": [11, 23, 5, 19, 15, 11, 16, 14, 17, 15, 12, 14, 16, 9] }, "Isaiah": { "chapters": 66, "versesPerChapter": [31, 22, 26, 6, 30, 13, 25, 22, 21, 34, 16, 6, 22, 32, 9, 14, 14, 7, 25, 6, 17, 25, 18, 23, 12, 21, 13, 29, 24, 33, 9, 20, 24, 17, 10, 22, 38, 22, 8, 31, 29, 25, 28, 28, 25, 13, 15, 22, 26, 11, 23, 15, 12, 17, 13, 12, 21, 14, 21, 22, 11, 12, 19, 12, 25, 24] }, "James": { "chapters": 5, "versesPerChapter": [27, 26, 18, 17, 20] }, "Jeremiah": { "chapters": 52, "versesPerChapter": [19, 37, 25, 31, 31, 30, 34, 22, 26, 25, 23, 17, 27, 22, 21, 21, 27, 23, 15, 18, 14, 30, 40, 10, 38, 24, 22, 17, 32, 24, 40, 44, 26, 22, 19, 32, 21, 28, 18, 16, 18, 22, 13, 30, 5, 28, 7, 47, 39, 46, 64, 34] }, "Job": { "chapters": 42, "versesPerChapter": [22, 13, 26, 21, 27, 30, 21, 22, 35, 22, 20, 25, 28, 22, 35, 22, 16, 21, 29, 29, 34, 30, 17, 25, 6, 14, 23, 28, 25, 31, 40, 22, 33, 37, 16, 33, 24, 41, 30, 24, 34, 17] }, "Joel": { "chapters": 3, "versesPerChapter": [20, 32, 21] }, "John": { "chapters": 21, "versesPerChapter": [51, 25, 36, 54, 47, 71, 53, 59, 41, 42, 57, 50, 38, 31, 27, 33, 26, 40, 42, 31, 25] }, "Jonah": { "chapters": 4, "versesPerChapter": [17, 10, 10, 11] }, "Joshua": { "chapters": 24, "versesPerChapter": [18, 24, 17, 24, 15, 27, 26, 35, 27, 43, 23, 24, 33, 15, 63, 10, 18, 28, 51, 9, 45, 34, 16, 33] }, "Jude": { "chapters": 1, "versesPerChapter": [25] }, "Judges": { "chapters": 21, "versesPerChapter": [36, 23, 31, 24, 31, 40, 25, 35, 57, 18, 40, 15, 25, 20, 20, 31, 13, 31, 30, 48, 25] }, "Lamentations": { "chapters": 5, "versesPerChapter": [22, 22, 66, 22, 22] }, "Leviticus": { "chapters": 27, "versesPerChapter": [17, 16, 17, 35, 19, 30, 38, 36, 24, 20, 47, 8, 59, 57, 33, 34, 16, 30, 37, 27, 24, 33, 44, 23, 55, 46, 34] }, "Luke": { "chapters": 24, "versesPerChapter": [80, 52, 38, 44, 39, 49, 50, 56, 62, 42, 54, 59, 35, 35, 32, 31, 37, 43, 48, 47, 38, 71, 56, 53] }, "Malachi": { "chapters": 4, "versesPerChapter": [14, 17, 18, 6] }, "Mark": { "chapters": 16, "versesPerChapter": [45, 28, 35, 41, 43, 56, 37, 38, 50, 52, 33, 44, 37, 72, 47, 20] }, "Matthew": { "chapters": 28, "versesPerChapter": [25, 23, 17, 25, 48, 34, 29, 34, 38, 42, 30, 50, 58, 36, 39, 28, 27, 35, 30, 34, 46, 46, 39, 51, 46, 75, 66, 20] }, "Micah": { "chapters": 7, "versesPerChapter": [16, 13, 12, 13, 15, 16, 20] }, "Nahum": { "chapters": 3, "versesPerChapter": [15, 13, 19] }, "Nehemiah": { "chapters": 13, "versesPerChapter": [11, 20, 32, 23, 19, 19, 73, 18, 38, 39, 36, 47, 31] }, "Numbers": { "chapters": 36, "versesPerChapter": [54, 34, 51, 49, 31, 27, 89, 26, 23, 36, 35, 16, 33, 45, 41, 50, 13, 32, 22, 29, 35, 41, 30, 25, 18, 65, 23, 31, 40, 16, 54, 42, 56, 29, 34, 13] }, "Obadiah": { "chapters": 1, "versesPerChapter": [21] }, "Philemon": { "chapters": 1, "versesPerChapter": [25] }, "Philippians": { "chapters": 4, "versesPerChapter": [30, 30, 21, 23] }, "Proverbs": { "chapters": 31, "versesPerChapter": [33, 22, 35, 27, 23, 35, 27, 36, 18, 32, 31, 28, 25, 35, 33, 33, 28, 24, 29, 30, 31, 29, 35, 34, 28, 28, 27, 28, 27, 33, 31] }, "Psalms": { "chapters": 150, "versesPerChapter": [6, 12, 8, 8, 12, 10, 17, 9, 20, 18, 7, 8, 6, 7, 5, 11, 15, 50, 14, 9, 13, 31, 6, 10, 22, 12, 14, 9, 11, 12, 24, 11, 22, 22, 28, 12, 40, 22, 13, 17, 13, 11, 5, 26, 17, 11, 9, 14, 20, 23, 19, 9, 6, 7, 23, 13, 11, 11, 17, 12, 8, 12, 11, 10, 13, 20, 7, 35, 36, 5, 24, 20, 28, 23, 10, 12, 20, 72, 13, 19, 16, 8, 18, 12, 13, 17, 7, 18, 52, 17, 16, 15, 5, 23, 11, 13, 12, 9, 9, 5, 8, 28, 22, 35, 45, 48, 43, 13, 31, 7, 10, 10, 9, 8, 18, 19, 2, 29, 176, 7, 8, 9, 4, 8, 5, 6, 5, 6, 8, 8, 3, 18, 3, 3, 21, 26, 9, 8, 24, 13, 10, 7, 12, 15, 21, 10, 20, 14, 9, 6] }, "Revelation": { "chapters": 22, "versesPerChapter": [20, 29, 22, 11, 14, 17, 17, 13, 21, 11, 19, 17, 18, 20, 8, 21, 18, 24, 21, 15, 27, 21] }, "Romans": { "chapters": 16, "versesPerChapter": [32, 29, 31, 25, 21, 23, 25, 39, 33, 21, 36, 21, 14, 23, 33, 27] }, "Ruth": { "chapters": 4, "versesPerChapter": [22, 23, 18, 22] }, "Song of Solomon": { "chapters": 8, "versesPerChapter": [17, 17, 11, 16, 16, 13, 13, 14] }, "Titus": { "chapters": 3, "versesPerChapter": [16, 15, 15] }, "Zechariah": { "chapters": 14, "versesPerChapter": [21, 13, 10, 14, 11, 15, 14, 23, 17, 12, 17, 14, 9, 21] }, "Zephaniah": { "chapters": 3, "versesPerChapter": [18, 15, 20] }
    },
    bookNames: ["Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy", "Joshua", "Judges", "Ruth", "1 Samuel", "2 Samuel", "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles", "Ezra", "Nehemiah", "Esther", "Job", "Psalms", "Proverbs", "Ecclesiastes", "Song of Solomon", "Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel", "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah", "Nahum", "Habakkuk", "Zephaniah", "Haggai", "Zechariah", "Malachi", "Matthew", "Mark", "Luke", "John", "Acts", "Romans", "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians", "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians", "1 Timothy", "2 Timothy", "Titus", "Philemon", "Hebrews", "James", "1 Peter", "2 Peter", "1 John", "2 John", "3 John", "Jude", "Revelation"]
  },
  WEB: {
    bookInfo: {
      "1 Chronicles": { "chapters": 29, "versesPerChapter": [54, 55, 24, 43, 26, 81, 40, 40, 44, 14, 47, 40, 14, 17, 29, 43, 27, 17, 19, 8, 30, 19, 32, 31, 31, 32, 34, 21, 30] }, "1 Corinthians": { "chapters": 16, "versesPerChapter": [31, 16, 23, 21, 13, 20, 40, 13, 27, 33, 34, 31, 13, 40, 58, 24] }, "1 John": { "chapters": 5, "versesPerChapter": [10, 29, 24, 21, 21] }, "1 Kings": { "chapters": 22, "versesPerChapter": [53, 46, 28, 34, 18, 38, 51, 66, 28, 29, 43, 33, 34, 31, 34, 34, 24, 46, 21, 43, 29, 53] }, "1 Peter": { "chapters": 5, "versesPerChapter": [25, 25, 22, 19, 14] }, "1 Samuel": { "chapters": 31, "versesPerChapter": [28, 36, 21, 22, 12, 21, 17, 22, 27, 27, 15, 25, 23, 52, 35, 23, 58, 30, 24, 42, 15, 23, 29, 22, 44, 25, 12, 25, 11, 31, 13] }, "1 Thessalonians": { "chapters": 5, "versesPerChapter": [10, 20, 13, 18, 28] }, "1 Timothy": { "chapters": 6, "versesPerChapter": [20, 15, 16, 16, 25, 21] }, "2 Chronicles": { "chapters": 36, "versesPerChapter": [17, 18, 17, 22, 14, 42, 22, 18, 31, 19, 23, 16, 22, 15, 19, 14, 19, 34, 11, 37, 20, 12, 21, 27, 28, 23, 9, 27, 36, 27, 21, 33, 25, 33, 27, 23] }, "2 Corinthians": { "chapters": 13, "versesPerChapter": [24, 17, 18, 18, 21, 18, 16, 24, 15, 18, 33, 21, 14] }, "2 John": { "chapters": 1, "versesPerChapter": [13] }, "2 Kings": { "chapters": 25, "versesPerChapter": [18, 25, 27, 44, 27, 33, 20, 29, 37, 36, 21, 21, 25, 29, 38, 20, 41, 37, 37, 21, 26, 20, 37, 20, 30] }, "2 Peter": { "chapters": 3, "versesPerChapter": [21, 22, 18] }, "2 Samuel": { "chapters": 24, "versesPerChapter": [27, 32, 39, 12, 25, 23, 29, 18, 13, 19, 27, 31, 39, 33, 37, 23, 29, 33, 43, 26, 22, 51, 39, 25] }, "2 Thessalonians": { "chapters": 3, "versesPerChapter": [12, 17, 18] }, "2 Timothy": { "chapters": 4, "versesPerChapter": [18, 26, 17, 22] }, "3 John": { "chapters": 1, "versesPerChapter": [14] }, "Acts": { "chapters": 28, "versesPerChapter": [26, 47, 26, 37, 42, 15, 60, 40, 43, 48, 30, 25, 52, 28, 41, 40, 34, 28, 41, 38, 40, 30, 35, 27, 27, 32, 44, 31] }, "Amos": { "chapters": 9, "versesPerChapter": [15, 16, 15, 13, 27, 14, 17, 14, 15] }, "Colossians": { "chapters": 4, "versesPerChapter": [29, 23, 25, 18] }, "Daniel": { "chapters": 12, "versesPerChapter": [21, 49, 30, 37, 31, 28, 28, 27, 27, 21, 45, 13] }, "Deuteronomy": { "chapters": 34, "versesPerChapter": [46, 37, 29, 49, 33, 25, 26, 20, 29, 22, 32, 32, 18, 29, 23, 22, 20, 22, 21, 20, 23, 30, 25, 22, 19, 19, 26, 68, 29, 20, 30, 52, 29, 12] }, "Ecclesiastes": { "chapters": 12, "versesPerChapter": [18, 26, 22, 16, 20, 12, 29, 17, 18, 20, 10, 14] }, "Ephesians": { "chapters": 6, "versesPerChapter": [23, 22, 21, 32, 33, 24] }, "Esther": { "chapters": 10, "versesPerChapter": [22, 23, 15, 17, 14, 14, 10, 17, 32, 3] }, "Exodus": { "chapters": 40, "versesPerChapter": [22, 25, 22, 31, 23, 30, 25, 32, 35, 29, 10, 51, 22, 31, 27, 36, 16, 27, 25, 26, 36, 31, 33, 18, 40, 37, 21, 43, 46, 38, 18, 35, 23, 35, 35, 38, 29, 31, 43, 38] }, "Ezekiel": { "chapters": 48, "versesPerChapter": [28, 10, 27, 17, 17, 14, 27, 18, 11, 22, 25, 28, 23, 23, 8, 63, 24, 32, 14, 49, 32, 31, 49, 27, 17, 21, 36, 26, 21, 26, 18, 32, 33, 31, 15, 38, 28, 23, 29, 49, 26, 20, 27, 31, 25, 24, 23, 35] }, "Ezra": { "chapters": 10, "versesPerChapter": [11, 70, 13, 24, 17, 22, 28, 36, 15, 44] }, "Galatians": { "chapters": 6, "versesPerChapter": [24, 21, 29, 31, 26, 18] }, "Genesis": { "chapters": 50, "versesPerChapter": [31, 25, 24, 26, 32, 22, 24, 22, 29, 32, 32, 20, 18, 24, 21, 16, 27, 33, 38, 18, 34, 24, 20, 67, 34, 35, 46, 22, 35, 43, 55, 32, 20, 31, 29, 43, 36, 30, 23, 23, 57, 38, 34, 34, 28, 34, 31, 22, 33, 26] }, "Habakkuk": { "chapters": 3, "versesPerChapter": [17, 20, 19] }, "Haggai": { "chapters": 2, "versesPerChapter": [15, 23] }, "Hebrews": { "chapters": 13, "versesPerChapter": [14, 18, 19, 16, 14, 20, 28, 13, 28, 39, 40, 29, 25] }, "Hosea": { "chapters": 14, "versesPerChapter": [11, 23, 5, 19, 15, 11, 16, 14, 17, 15, 12, 14, 16, 9] }, "Isaiah": { "chapters": 66, "versesPerChapter": [31, 22, 26, 6, 30, 13, 25, 22, 21, 34, 16, 6, 22, 32, 9, 14, 14, 7, 25, 6, 17, 25, 18, 23, 12, 21, 13, 29, 24, 33, 9, 20, 24, 17, 10, 22, 38, 22, 8, 31, 29, 25, 28, 28, 25, 13, 15, 22, 26, 11, 23, 15, 12, 17, 13, 12, 21, 14, 21, 22, 11, 12, 19, 12, 25, 24] }, "James": { "chapters": 5, "versesPerChapter": [27, 26, 18, 17, 20] }, "Jeremiah": { "chapters": 52, "versesPerChapter": [19, 37, 25, 31, 31, 30, 34, 22, 26, 25, 23, 17, 27, 22, 21, 21, 27, 23, 15, 18, 14, 30, 40, 10, 38, 24, 22, 17, 32, 24, 40, 44, 26, 22, 19, 32, 21, 28, 18, 16, 18, 22, 13, 30, 5, 28, 7, 47, 39, 46, 64, 34] }, "Job": { "chapters": 42, "versesPerChapter": [22, 13, 26, 21, 27, 30, 21, 22, 35, 22, 20, 25, 28, 22, 35, 22, 16, 21, 29, 29, 34, 30, 17, 25, 6, 14, 23, 28, 25, 31, 40, 22, 33, 37, 16, 33, 24, 41, 30, 24, 34, 17] }, "Joel": { "chapters": 3, "versesPerChapter": [20, 32, 21] }, "John": { "chapters": 21, "versesPerChapter": [51, 25, 36, 54, 47, 71, 53, 59, 41, 42, 57, 50, 38, 31, 27, 33, 26, 40, 42, 31, 25] }, "Jonah": { "chapters": 4, "versesPerChapter": [17, 10, 10, 11] }, "Joshua": { "chapters": 24, "versesPerChapter": [18, 24, 17, 24, 15, 27, 26, 35, 27, 43, 23, 24, 33, 15, 63, 10, 18, 28, 51, 9, 45, 34, 16, 33] }, "Jude": { "chapters": 1, "versesPerChapter": [25] }, "Judges": { "chapters": 21, "versesPerChapter": [36, 23, 31, 24, 31, 40, 25, 35, 57, 18, 40, 15, 25, 20, 20, 31, 13, 31, 30, 48, 25] }, "Lamentations": { "chapters": 5, "versesPerChapter": [22, 22, 66, 22, 22] }, "Leviticus": { "chapters": 27, "versesPerChapter": [17, 16, 17, 35, 19, 30, 38, 36, 24, 20, 47, 8, 59, 57, 33, 34, 16, 30, 37, 27, 24, 33, 44, 23, 55, 46, 34] }, "Luke": { "chapters": 24, "versesPerChapter": [80, 52, 38, 44, 39, 49, 50, 56, 62, 42, 54, 59, 35, 35, 32, 31, 37, 43, 48, 47, 38, 71, 56, 53] }, "Malachi": { "chapters": 4, "versesPerChapter": [14, 17, 18, 6] }, "Mark": { "chapters": 16, "versesPerChapter": [45, 28, 35, 41, 43, 56, 37, 38, 50, 52, 33, 44, 37, 72, 47, 20] }, "Matthew": { "chapters": 28, "versesPerChapter": [25, 23, 17, 25, 48, 34, 29, 34, 38, 42, 30, 50, 58, 36, 39, 28, 27, 35, 30, 34, 46, 46, 39, 51, 46, 75, 66, 20] }, "Micah": { "chapters": 7, "versesPerChapter": [16, 13, 12, 13, 15, 16, 20] }, "Nahum": { "chapters": 3, "versesPerChapter": [15, 13, 19] }, "Nehemiah": { "chapters": 13, "versesPerChapter": [11, 20, 32, 23, 19, 19, 73, 18, 38, 39, 36, 47, 31] }, "Numbers": { "chapters": 36, "versesPerChapter": [54, 34, 51, 49, 31, 27, 89, 26, 23, 36, 35, 16, 33, 45, 41, 50, 13, 32, 22, 29, 35, 41, 30, 25, 18, 65, 23, 31, 40, 16, 54, 42, 56, 29, 34, 13] }, "Obadiah": { "chapters": 1, "versesPerChapter": [21] }, "Philemon": { "chapters": 1, "versesPerChapter": [25] }, "Philippians": { "chapters": 4, "versesPerChapter": [30, 30, 21, 23] }, "Proverbs": { "chapters": 31, "versesPerChapter": [33, 22, 35, 27, 23, 35, 27, 36, 18, 32, 31, 28, 25, 35, 33, 33, 28, 24, 29, 30, 31, 29, 35, 34, 28, 28, 27, 28, 27, 33, 31] }, "Psalms": { "chapters": 150, "versesPerChapter": [6, 12, 8, 8, 12, 10, 17, 9, 20, 18, 7, 8, 6, 7, 5, 11, 15, 50, 14, 9, 13, 31, 6, 10, 22, 12, 14, 9, 11, 12, 24, 11, 22, 22, 28, 12, 40, 22, 13, 17, 13, 11, 5, 26, 17, 11, 9, 14, 20, 23, 19, 9, 6, 7, 23, 13, 11, 11, 17, 12, 8, 12, 11, 10, 13, 20, 7, 35, 36, 5, 24, 20, 28, 23, 10, 12, 20, 72, 13, 19, 16, 8, 18, 12, 13, 17, 7, 18, 52, 17, 16, 15, 5, 23, 11, 13, 12, 9, 9, 5, 8, 28, 22, 35, 45, 48, 43, 13, 31, 7, 10, 10, 9, 8, 18, 19, 2, 29, 176, 7, 8, 9, 4, 8, 5, 6, 5, 6, 8, 8, 3, 18, 3, 3, 21, 26, 9, 8, 24, 13, 10, 7, 12, 15, 21, 10, 20, 14, 9, 6] }, "Revelation": { "chapters": 22, "versesPerChapter": [20, 29, 22, 11, 14, 17, 17, 13, 21, 11, 19, 17, 18, 20, 8, 21, 18, 24, 21, 15, 27, 21] }, "Romans": { "chapters": 16, "versesPerChapter": [32, 29, 31, 25, 21, 23, 25, 39, 33, 21, 36, 21, 14, 26, 33, 24] }, "Ruth": { "chapters": 4, "versesPerChapter": [22, 23, 18, 22] }, "Song of Solomon": { "chapters": 8, "versesPerChapter": [17, 17, 11, 16, 16, 13, 13, 14] }, "Titus": { "chapters": 3, "versesPerChapter": [16, 15, 15] }, "Zechariah": { "chapters": 14, "versesPerChapter": [21, 13, 10, 14, 11, 15, 14, 23, 17, 12, 17, 14, 9, 21] }, "Zephaniah": { "chapters": 3, "versesPerChapter": [18, 15, 20] }
    },
    bookNames: ["Genesis", "Exodus", "Leviticus", "Numbers", "Deuteronomy", "Joshua", "Judges", "Ruth", "1 Samuel", "2 Samuel", "1 Kings", "2 Kings", "1 Chronicles", "2 Chronicles", "Ezra", "Nehemiah", "Esther", "Job", "Psalms", "Proverbs", "Ecclesiastes", "Song of Solomon", "Isaiah", "Jeremiah", "Lamentations", "Ezekiel", "Daniel", "Hosea", "Joel", "Amos", "Obadiah", "Jonah", "Micah", "Nahum", "Habakkuk", "Zephaniah", "Haggai", "Zechariah", "Malachi", "Matthew", "Mark", "Luke", "John", "Acts", "Romans", "1 Corinthians", "2 Corinthians", "Galatians", "Ephesians", "Philippians", "Colossians", "1 Thessalonians", "2 Thessalonians", "1 Timothy", "2 Timothy", "Titus", "Philemon", "Hebrews", "James", "1 Peter", "2 Peter", "1 John", "2 John", "3 John", "Jude", "Revelation"]
  }
}
